import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateCustomField($companyId: ID!, $attributes: CustomFieldAttributes!) {
    createCustomField(companyId: $companyId, attributes: $attributes) {
      customField {
        id
        ...CreatedCustomField
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedCustomField on CustomField {
    id
    name
    resourceType
    fieldType
    enabled
  }
`
